import { createRoot } from "react-dom/client";
import "@shopify/polaris/build/esm/styles.css";
import "./styles/styles.css";
import App from "./App";

createRoot(document.getElementById("root")!).render(<App />);
